import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import Loader from '../../components/common/loader'
import PrivateRoutes from './privateRoutes'
import AppHeader from '../../components/app/appHeader'
import LeftPanel from '../../components/app/leftPanel'

import * as actions from './actions'
import { routePrefix } from '../../config'

import './styles.css'
import '../../components/common/commonCompStyles.css'
import { triggerPulse, opdbGTM } from '../../utils/pulseUtils'
import { fetchMerchantId } from '../../utils'
class AppContainer extends React.Component {

  state = {};

  componentDidMount() {
    triggerPulse();
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://webappsstatic.paytm.com/signalsdk-web/v1/config-2.2.0.min.js';
    document.body.appendChild(script);
    let merchantCode = localStorage.getItem('merchant-id');
    const merchantId = fetchMerchantId();
    if(merchantId) {
      merchantCode = merchantId;
    }
    const query = merchantCode ? {merchant: merchantCode} : {};
    this.props.getAllRoutesInfo(query)
  }

  onLogoutClick = () => this.props.onLogout()

  render() {
    const { escalationMatrix } = this.props;
    if (!this.props.isLoggedIn) {
      return <Redirect to={`${routePrefix}/login`} />
    }
    return (
      <div>
        {this.props.isShowLoader && <Loader />}
        <AppHeader
          operatorDetails={this.props.operatorDetails}
          onLogoutClick={this.onLogoutClick}
          allRoutesInfo={this.props.allRoutesInfo}
          escalationMatrix={escalationMatrix}
          getEscalationMatrixInfo={this.props.getEscalationMatrixInfo}
        />
        <div className="row">
          <LeftPanel
            operatorDetails={this.props.operatorDetails}
            allRoutesInfo={this.props.allRoutesInfo}
            operatorInfo={this.props.operatorInfo}
          />
          <div className="col-xs-10 route-pages" style={{ paddingLeft: "0px"}} id="route-pages">
            <PrivateRoutes />
            <div className="copyright-wrp">
              Copyright © 2020 <span className="brand-name">Paytm</span>. All rights
              reserved.
            </div>
          </div>
        </div>
      </div>
    )
  }
}


const mapStateToProps = store => ({
  isLoggedIn: store.userInfoReducer.isLoggedIn,
  operatorDetails: store.userInfoReducer.operatorDetails,
  isShowLoader: store.utilityReducer.isShowLoader,
  allRoutesInfo: store.userInfoReducer.allRoutesInfo,
  merchantCode: store.userInfoReducer.merchantCode,
  escalationMatrix: store.userInfoReducer.escalationMatrix,
  operatorInfo: store.userInfoReducer.operatorInfo,
})

const mapDispatchToProps = dispatch => ({
  onLogout: () => dispatch(actions.onLogout()),
  // getAccessToken: () => dispatch(actions.getAccessToken()),
  getAllRoutesInfo: (query) => dispatch(actions.getAllRoutesInfo(query)),
  getEscalationMatrixInfo: () => dispatch(actions.getEscalationMatrixInfo()),
  setMerchantId: (merchantId) => dispatch(actions.setMerchantId(merchantId))
})

AppContainer.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  merchantId: PropTypes.string.isRequired,
  onLogout: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer)
